import isEqual from 'lodash/isEqual';
import { mapState } from 'vuex';

import bus from '@/utils/bus';
import MenuItemOptionWrapper from '../MenuItemOptionWrapper/MenuItemOptionWrapper.vue';
import MenuItemOptionsSelector from '../MenuItemOptionsSelector/MenuItemOptionsSelector.vue';

export default {
  name: 'MenuItemsEditorEntreeDetails',
  components: {
    MenuItemOptionWrapper,
    MenuItemOptionsSelector,
  },
  props: {
    categories: {
      required: true,
      type: Array,
    },
    entree: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      entreeOptions: [],
      note: this.entree?.storeNote || '',
      options: [],
    };
  },
  computed: {
    ...mapState('menu', ['menu']),
    name: {
      get() {
        return this.entree?.name;
      },
      set(val) {
        this.entree.setName(val);
      },
    },
    price: {
      get() {
        return this.entree?.price;
      },
      set(val) {
        this.entree.setPrice(val);
      },
    },
  },
  watch: {
    entree: {
      deep: true,
      handler(newVal, oldVal) {
        if (!isEqual(newVal, oldVal)) {
          this.entreeOptions = newVal?.options || [];
          this.note = newVal?.storeNote || '';
          this.setOptions();
          bus.$emit('CLOSE_OPTIONS_SELECTOR');
        }
      },
      immediate: true,
    },
    note(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.entree.setStoreNote(newVal);
      }
    },
  },
  created() {
    this.setOptions();

    bus.$on('SET_ENTREE_OPTIONS', (optionIndexes = []) => {
      if (!optionIndexes?.length) {
        return;
      }
      optionIndexes.forEach((optionIndex) => {
        const option = this.menu?.getOption(optionIndex);
        if (option) {
          this.$emit('add-option-to-entree', option);
        }
      });
      this.setOptions();
    });
  },
  methods: {
    getCategoryNameById(categoryIndex) {
      const { name = '' } = this.menu?.getCategory(categoryIndex) || {};
      return name;
    },
    removeEntreeOption(option) {
      this.entree.removeOption(option);
      this.setOptions();
    },
    setOptions() {
      const menuOptions = this.menu?.options || [];
      const filteredOptions = menuOptions.filter(
        ({ index }) => !this.entreeOptions?.find(
          (({ index: entreeOptionIndex }) => entreeOptionIndex === index),
        ),
      ) || [];
      this.options = this.entreeOptions?.length ? filteredOptions : menuOptions;
    },
  },
};
